import { createFileRoute } from '@tanstack/react-router';
import { PresentationAudiencePage } from '../features/presentations/presentation-presenter-page';
export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience',
)({ component: PresentationAudiencePage });
